
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import UtilResponse from "@/utils/UtilResponse.js";
import useColaboradorStore from "@stores/ColaboradorStore.js";

export default {

    async liberarItens(ordemDeServicoItensValores = []) {

        const colaboradorStore = useColaboradorStore();
        const usuarioLogado = colaboradorStore?.colaborador?.nome || "";

        let ordemDeServicoItens;

        try{

            //==================================================================//
            //=========== Alterar Itens da Ordem de Servico ====================//
            //==================================================================//

            ordemDeServicoItensValores = ordemDeServicoItensValores.map(item => ({
                id: item.id,
                status: item.status
            }));

            const alteracaoDescricao = `Alterado de Status por ${usuarioLogado}`;

            ordemDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensValores, alteracaoDescricao);
            if (UtilResponse.isNotOk(ordemDeServicoItens)) {
                throw ordemDeServicoItens;
            }

            return ordemDeServicoItens;

        }catch(e){

            console.log(e);
            return ordemDeServicoItens;

        }
        
    },

}